var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBegineerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20570_48257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.374 7.50684C12.0043 7.57092 12.4961 8.10285 12.4961 8.75V16.75L12.4893 16.8779C12.4294 17.4661 11.9622 17.9334 11.374 17.9932L11.2461 18H8.24609C7.59894 18 7.06702 17.5082 7.00293 16.8779L6.99609 16.75V8.75C6.99609 8.05964 7.55574 7.5 8.24609 7.5H11.2461L11.374 7.50684ZM17.8701 1.50586C18.5004 1.56995 18.9922 2.10187 18.9922 2.74902V16.749L18.9854 16.877C18.9255 17.4651 18.4583 17.9324 17.8701 17.9922L17.7422 17.999H14.7422C14.095 17.999 13.5631 17.5072 13.499 16.877L13.4922 16.749V2.74902C13.4922 2.05867 14.0518 1.49902 14.7422 1.49902H17.7422L17.8701 1.50586ZM4.74609 10.998C5.43645 10.998 5.99609 11.5577 5.99609 12.248V16.748C5.99609 17.4384 5.43645 17.998 4.74609 17.998H1.74609C1.05574 17.998 0.496094 17.4384 0.496094 16.748V12.248C0.496094 11.5577 1.05574 10.998 1.74609 10.998H4.74609ZM8.24609 16.75H11.2461V8.75H8.24609V16.75ZM14.7422 16.749H17.7422V2.74902H14.7422V16.749Z",
    fill: "#F8D210"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20570_48257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBegineerIcon);
export default __webpack_public_path__ + "static/media/BegineerIcon.56f0ad91f523b6b1d5b9b0a3d1ebf60f.svg";
export { ForwardRef as ReactComponent };